export const fallback = (value?: string | number | null, empty = "N/A") => {
  if (value === null || value === undefined) return empty;
  if (typeof value === "string" && !value.trim()) return empty;
  return value;
};

export const formatCurrency = (value?: string | number | null) => {
  if (value === null || value === undefined || value === "") return "N/A";

  const numericValue =
    typeof value === "string" ? Number(value.replace(/,/g, "")) : value;

  if (Number.isNaN(numericValue)) return "N/A";

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(numericValue);
};

export const formatDate = (value?: string | null) => {
  if (!value) return "N/A";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "N/A";

  return new Intl.DateTimeFormat("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
};

export const formatCategory = (value?: string | null) => {
  if (!value) return "N/A";

  return value
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

export const getInitials = (name?: string, surname?: string) => {
  const first = name?.charAt(0)?.toUpperCase() || "";
  const last = surname?.charAt(0)?.toUpperCase() || "";
  return `${first}${last}` || "NA";
};
